<div class="field" [ngStyle]="{'padding-bottom': (hasAlert) ? '15px' : '0px'}">
  <!-- State type dimension -->
  <ng-template [ngIf]="isState">
    <label [attr.for]="id" soho-label>{{dimension.label}}</label>
    <select
        soho-dropdown
        [ngClass]="'dropdown-md'"
        [attr.id]="id"
        [(ngModel)]="dimension.value"
    >
      <option [value]="''">{{''}}</option>
      <option *ngFor="let option of dimension.states" [value]="option.value">{{option.label}}</option>
    </select>
  </ng-template>

  <!-- Boolean type dimension -->
  <ng-template [ngIf]="isBoolean">
    <label [attr.for]="id" soho-label>{{dimension.label}}</label>
    <select
        soho-dropdown
        [ngClass]="'dropdown-md'"
        [attr.id]="id"
        [(ngModel)]="dimension.value"
    >
      <option [value]="''">{{''}}</option>
      <option [value]="'true'">{{'Yes' | translate}}</option>
      <option [value]="'false'">{{'No' | translate}}</option>
    </select>
  </ng-template>

  <!-- Period dimension -->
  <ng-template [ngIf]="isPeriod">
    <lm-cube-period-dimension
        [dimension]="dimension"
    >
    </lm-cube-period-dimension>
  </ng-template>

  <!-- Key field dimension -->

  <ng-template [ngIf]="isKeyField">
    <lm-lookup-basic
        [cubeBusClass]="cubeBusClass"
        [cubeDimension]="dimension"
        [selectListUrl]="selectListUrl"
        [cubeGetFieldsUrl]="getFieldsUrl"
        [showAlert]="structures && hasReportingBasis"
        [topNodeBaseValue]="topNodeBaseValue"
        (onLookupValueChangedEvent)="fieldValueChanged($event)"
    >
    </lm-lookup-basic>
  </ng-template>

  <!-- Other dimension -->
  <ng-template [ngIf]="isText">
    <label [attr.for]="id" soho-label>{{dimension.label}}</label>
    <input
        soho-input
        [attr.id]="id"
        [(ngModel)]="dimension.value"
    />
  </ng-template>
</div>
